export default function HelpIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9C9 7.89543 9.89543 7 11 7H13.1922C14.1906 7 15 7.80936 15 8.80776C15 9.63729 14.4354 10.3604 13.6307 10.5616L12.5149 10.8405C11.6246 11.0631 11 11.863 11 12.7808V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14L13 12.7808L14.1158 12.5018C15.8108 12.0781 17 10.555 17 8.80776C17 6.70479 15.2952 5 13.1922 5H11C8.79086 5 7 6.79086 7 9C7 9.55228 7.44772 10 8 10C8.55228 10 9 9.55228 9 9ZM12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
